<div class="store-page">
  <!-- Row 1: Explore Categories -->

  <section class="store-section">
    <div class="store-cards-grid">
      @for (card of exploreCards; track card.colorClass) {
        <ddc-store-card
          [colorClass]="card.colorClass"
          [icon]="card.icon"
          [subtitle]="card.subtitle"
          [title]="card.title"
          (click)="onCardClick(card)"
        ></ddc-store-card>
      }
    </div>
  </section>

  <ddc-divider text="Create with Lingo AI"></ddc-divider>

  <!-- Row 3: Create with Lingo AI -->
  <section class="store-section">
    <div class="store-cards-grid">
      @for (card of lingoCards; track card.colorClass) {
        <ddc-store-card
          [colorClass]="card.colorClass"
          [icon]="card.icon"
          [lingoBadgeSrc]="lingoBadgeSrc"
          [subtitle]="card.subtitle"
          [title]="card.title"
          (click)="onCardClick(card)"
        ></ddc-store-card>
      }
    </div>
  </section>

  <!-- Row 2: Explored Dictionaries Carousel -->
  <ddc-divider text="Check out new dictionaries"></ddc-divider>

  <section class="store-section">
    <ddc-explored-cards></ddc-explored-cards>
  </section>
</div>
